import Audio from '../classes/audio-player'

export default {
  install(Vue) {
    Vue.prototype.$aPlayer = new Audio({
      path: '/audio/',
      volume: .25
    }).init()
  }
}